import { Phone, MessageCircle, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube, Twitter } from "lucide-react";
import { company } from "../mock/mock";

export default function TopBar() {
  return (
    <div className="hidden md:block bg-[#0d2240] text-white text-xs">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-5 flex-wrap">
          <a
            href={`tel:+91${company.phone}`}
            className="flex items-center gap-2 hover:text-[#f4b223] transition-colors"
          >
            <span className="w-6 h-6 rounded-full bg-[#c8102e] grid place-items-center">
              <Phone size={12} />
            </span>
            <span className="font-medium tracking-wide">+91 {company.phone}</span>
          </a>
          <a
            href={`https://wa.me/91${company.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 hover:text-[#f4b223] transition-colors"
          >
            <span className="w-6 h-6 rounded-full bg-[#25D366] grid place-items-center">
              <MessageCircle size={12} />
            </span>
            <span className="font-medium tracking-wide">+91 {company.whatsapp}</span>
          </a>
          <a
            href={`mailto:${company.email}`}
            className="flex items-center gap-2 hover:text-[#f4b223] transition-colors"
          >
            <span className="w-6 h-6 rounded-full bg-[#c8102e] grid place-items-center">
              <Mail size={12} />
            </span>
            <span className="font-medium tracking-wide">{company.email}</span>
          </a>
          <span className="hidden lg:flex items-center gap-2 text-white/70">
            <MapPin size={13} />
            <span>Vadodara, Gujarat - 391 740</span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-white/70 mr-2">Follow us:</span>
          {[
            { Icon: Facebook, href: company.social.facebook, label: "Facebook" },
            { Icon: Instagram, href: company.social.instagram, label: "Instagram" },
            { Icon: Linkedin, href: company.social.linkedin, label: "LinkedIn" },
            { Icon: Youtube, href: company.social.youtube, label: "YouTube" },
            { Icon: Twitter, href: company.social.twitter, label: "Twitter" },
          ].map(({ Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              className="w-7 h-7 grid place-items-center rounded-full bg-white/10 hover:bg-[#c8102e] hover:scale-110 transition-all"
            >
              <Icon size={13} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
